<template>
  <section class="cases">
    <div class="section-wrap">
      <Header :trigger="trigger"/>
    </div>
    <div class="container">
      <h1 class="promo__head">i take pride in the cases which i've done over the past 10 years, ranging from small blogs to larger complex websites</h1>
      <p class="promo__text">here is a short example of the diverse list of cases - working at agencies and larger companies alike</p>
      <section class="cases__cases about__split">
        <div>
            <a class="link" href="https://thefwa.com">
              <h2>the fwa</h2>
            </a>
            <p class="cases__list__case__text">the favourite website awards, is a site which has existed since 2000. Therefor it was time for a major overhaul! Hello Monday delivered the design and konform delivered the development. i was one of two frontend developers working on the project and i've therefore been in charge of making most of the views and most of the javascript, html and css on the site. <br><br>the site is made in react, as it functions as an spa.</p>
        </div>
        <div>
          <a class="link" href="https://dahllaw.dk">
            <h2>dahl law</h2>
          </a>
          <p class="cases__list__case__text">dahl law is a lawyer firm i denmark, who needed a new website. i was one of two frontend developers working on this assignment at konform.</p>
        </div>
        <div>
          <a class="link" href="https://thehub.dk">
            <h2>thehub.dk</h2>
          </a>
          <p class="cases__list__case__text">thehub.dk is a danish job-index for startups. i worked on maintaining both the frontend and backend of the site, while working at rainmaking.</p>
        </div>
        <div>
          <a class="link" href="https://projecthalfdouble.dk">
            <h2>projecthalfdouble.dk</h2>
          </a>
          <p class="cases__list__case__text">a simple website for the project named 'project half double'. on this site, we decided to play with rendering of 3D models in the browser and interaction with these.</p>
        </div>
      </section>
    </div>
  </section>
</template>

<script>
import './style.scss';
import Header from '@/components/Header/Header';

export default {
  name: 'Frederik',
  data() {
    return {
    };
  },
  methods: {
  },
  components: {
    Header,
  },
  props: {
    trigger: Function,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Cases/Frederik.vue